import { useDataProvider } from '@pankod/refine-core';

import { getSdk } from 'api-client';

export function useApiSdk() {
    const dataProvider = useDataProvider()();
    const apiClient = dataProvider.getClient();
    return getSdk(apiClient);
}
